(function() {
  'use strict';

  /* jshint undef: true */
  /* global _:false */
  angular
    .module('linshare.resetPassword')
    .constant('_', _);
})();
